import axios from 'axios'
import fileDowload from 'js-file-download';

export const GetDocInfoListByRecipientId = async (recipientId: string) => {
  try {
      const baseUrl = process.env.REACT_APP_API_BASE_URL;
      const response = await axios.get(`${baseUrl}/document-list-by-recipientId/${recipientId}/info`);
      return response;
  } catch (error: any) {       
    throw HandleErrorLogging(error, `GetDocInfoListByRecipientId() recipient: ${recipientId}`);
  }
};

export async function UploadDocumentAsync(
  docEncoded: string,
  docId: string,
  docName: string,
  docType: string,
  caregiverId: string,
  recipientId: string,
  onProgress: (progressEvent: ProgressEvent) => void,
): Promise<any> {
  try {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;     

    const uploadDocumentRequest = {
      documentId: docId,
      fileName: docName,
      fileType: docType,
      // content: docEncoded,
      caregiverId: caregiverId, 
      recipientId: recipientId
    }
    const result =  await axios.put(`${baseUrl}/documents`, uploadDocumentRequest);    
    const jsonString = result.data;
    const url  = JSON.parse(jsonString)?.url
    const headers = {
      "Content-Type": docType,
    };
    const docUploadres =  await axios.put(url, docEncoded,{ headers, baseURL: "", onUploadProgress: onProgress });  
    return docUploadres.status;
  } 
  catch (error: any) {       
    return HandleErrorLogging(error, `UploadDocumentAsync() documentName: ${docName}`);
  }
}

export async function UploadDocInfoAsync(
  docId: string,
  caregiverId: string,
  recipientId: string,
  recipientName: string,
  domain: string,
  tasks: string,
  file: File,
): Promise<any> {
  try {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;     

    const lastModified = new Date(file.lastModified);

    const uploadDocumentInfoRequest = {
      documentId: docId,
      caregiverId: caregiverId,
      recipientId: recipientId, 
      recipientName: recipientName,
      domain: domain,
      tasks: tasks,
      fileName: file.name,
      fileType: file.type,
      fileSize: file.size,
      lastModifiedOn: lastModified.toUTCString() 
    }

    const result = await axios.put(`${baseUrl}/documents/${docId}/info`, uploadDocumentInfoRequest);
    return result.status;
  } 
  catch (error: any) {       
    return HandleErrorLogging(error, `UploadDocInfoAsync() documentName: ${file.name}`);
  }
}

export async function DeleteDocumentAsync(
  docId: string,
  docName: string,
  caregiverId: string,
  recipientId: string
): Promise<any> {
  try {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;     

    const deleteDocumentRequest = {
      documentId: docId,
      fileName: docName,
      caregiverId, 
      recipientId
    }
    
    const result = await fetch(`${baseUrl}/documents`, {
      signal: Timeout(10).signal,
      method: 'delete',
      mode: 'cors',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(deleteDocumentRequest),
    });
    return result.status;
  } 
  catch (error: any) {    
    if (error.name === "TimeoutError") {
      return `Delete document timed out at 5000ms. ${error}`
    }  

    return HandleErrorLogging(error, `DeleteDocumentAsync() documentName: ${docName}`);
  }
}

export async function DeleteDocInfoAsync(documentId: string): Promise<any> { 
  try {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const result = await axios.delete(`${baseUrl}/documents/${documentId}/info`);
    return result.status;
  } 
  catch (error: any) {       
    return HandleErrorLogging(error, `DeleteDocInfoAsync() documentId: ${documentId}`);
  }
}

export async function DownloadDocumentAsync(
  documentId: string,
  fileName: string,
  caregiverId: string,
  recipientId: string
) : Promise<void> {
  try {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const requestUrl = `${baseUrl}/documents/${documentId}/${caregiverId}/${recipientId}/${fileName}`;
    const resultUrl = await axios.get(requestUrl);
    const resultFile = await axios.get(resultUrl.data, { baseURL: '', responseType: 'blob',  });
    
    fileDowload(resultFile.data, fileName);
  } 
  catch (error: any) {
    throw HandleErrorLogging(error, `DownloadDocumentAsync() fileName: ${fileName}`);
  }
}

export const Timeout = (seconds: number) => {
	let controller = new AbortController();
	setTimeout(() => controller.abort(), seconds * 1000);
	return controller;
};

const HandleErrorLogging = (error: any, extraDetails: string) => {
  var errorMessage = "";

  if (error.name === "TimeoutError") {
    console.error("Timeout: It took more than 9 seconds to get the result!");
  } else if (error.name === "AbortError") {
    console.error( "Fetch aborted by user action (browser stop button, closing tab, etc.");
  } else if (error.name === "TypeError") {
    console.error("AbortSignal.timeout() method is not supported");
  } else {
    // A network error, or some other problem.
    console.error(`Error: type: ${error.name}, message: ${error.message}`);
  }

  if (error.response) {
      errorMessage = `Error: Request made, but the server responded with an error. ErrorResponse: ${error.response}. `;
      console.error(error.response.data);
      console.error(error.response.status);
      console.error(error.response.headers);
  } else if (error.request) {
      errorMessage = `Error: Request made but no response is received from the server. ErrorRequest: ${error.request}. `;
      console.error(error.request);
  } else {
      errorMessage = `Error: This occured while setting up the request. Error: type: ${error.name}, message: ${error.message} `;
      console.error('Error', error.message);
  }
  
  errorMessage += ` ExtraDetails:  ${extraDetails};`
  return errorMessage;
}